import React from 'react';
import { Link } from 'react-router-dom';
import { Hammer } from 'lucide-react';

const Logo = ({ variant = 'default', className = '' }) => {
  const textColor = variant === 'light' ? 'text-white' : 'text-dark-900';
  const subTextColor = variant === 'light' ? 'text-white/50' : 'text-dark-400';

  return (
    <Link to="/" className={`flex items-center gap-3 group ${className}`}>
      <div className="w-11 h-11 rounded-xl bg-athletic-600 flex items-center justify-center shadow-button group-hover:bg-athletic-700 transition-colors">
        <Hammer className="w-[22px] h-[22px] text-white" strokeWidth={2} />
      </div>
      <div className="flex flex-col leading-none">
        <span className={`font-display text-[1.4rem] font-semibold tracking-tight ${textColor} transition-colors`}>
          Ironworks<span className="text-athletic-600"> Tools</span>
        </span>
        <span className={`text-[10px] font-semibold uppercase tracking-[0.24em] mt-1.5 ${subTextColor} transition-colors`}>
          Hardware &amp; Tool Supply
        </span>
      </div>
    </Link>
  );
};

export default Logo;
